import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  inject,
} from '@angular/core';
import { UserManagementService } from '../user-management.service';
import {
  UntypedFormGroup,
  FormGroup,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {
  MatAutocompleteSelectedEvent,
  MatAutocompleteModule,
} from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import {
  startWith,
  map,
  debounceTime,
  distinctUntilChanged,
} from 'rxjs/operators';
import { AdminService } from '../../admin.service';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
  imports: [
    MatSelectModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class AddUserComponent implements OnInit {
  dialogRef = inject<MatDialogRef<AddUserComponent>>(MatDialogRef);
  private userService = inject(UserManagementService);
  private adminService = inject(AdminService);

  userForm: FormGroup;
  filteredUnits = [];
  units = [];
  createRepcode = true;
  @Input() unitData; // = ['Home Office', 'New Unit'];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  @ViewChild('unitInput', { static: false })
  unitInput: ElementRef<HTMLInputElement>;
  unitDropdownNoResults: boolean;
  unitDropdownLoading: boolean;

  constructor() {
    const formGroup = {};
    formGroup['userid'] = new FormControl();
    formGroup['email'] = new FormControl();
    formGroup['unit'] = new FormControl();
    formGroup['createrepcode'] = new FormControl();
    formGroup['firstName'] = new FormControl();
    formGroup['lastName'] = new FormControl();
    this.userForm = new UntypedFormGroup(formGroup);
  }

  ngOnInit() {
    this.userForm
      .get('unit')
      .valueChanges.pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((unit: string | null) =>
        unit && unit.length > 1 ? this._filterUnits(unit) : null
      );
  }

  checkSelection() {
    if (
      !this.userForm.get('unit').value ||
      !this.filteredUnits ||
      !this.filteredUnits.find(unit => {
        return (
          unit.id.toLowerCase() ===
          this.userForm.get('unit').value.toLowerCase()
        );
      })
    ) {
      this.userForm.get('unit').setValue(null);
    }
  }

  save() {
    if (this.userForm.valid) {
      this.dialogRef.close({ data: this.userForm.value });
      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = null;
      });
    }
  }

  cancel() {
    this.dialogRef.close();
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }

  addItem(
    event: MatChipInputEvent,
    items: Array<any>,
    control: FormControl
  ): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      items.push(value.trim());
    }

    if (input) {
      input.value = '';
    }

    control.setValue(null);
  }

  checkUserId(event: Event) {
    const userid = this.userForm.get('userid').value;
    this.userForm.get('userid').setErrors(null);
    this.userService.userInfo(userid).subscribe((info: string) => {
      if (userid.length > 0 && info.indexOf(userid) > -1) {
        this.userForm.get('userid').setErrors({ notUnique: true });
      } else {
        this.userForm.get('userid').updateValueAndValidity();
      }
    });
  }

  private _filterItem(value: string, items: Array<any>): string[] {
    const filterValue = value.toLowerCase();

    return items.filter(unit => unit.toLowerCase().indexOf(filterValue) === 0);
  }

  private _filterUnits(value: string): void {
    const filterValue = value.toLowerCase();

    this.unitDropdownNoResults = false;
    this.unitDropdownLoading = true;

    this.adminService.getUnitList(filterValue, true).subscribe(res => {
      this.filteredUnits = res.names;
      this.unitDropdownLoading = false;
      this.unitDropdownNoResults = this.filteredUnits.length === 0;
    });
  }

  public createRepcodeChanged(event: Event) {
    if (this.userForm.get('createrepcode').value === true) {
      this.userForm.get('unit').enable();
    } else {
      this.userForm.get('unit').setValue(null);
      this.userForm.get('unit').disable();
    }
  }
}
